import React, { useEffect, useMemo, useState } from "react"
import axios from "axios"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "./tableContainer"
import { HOSTNAME } from "config/config"
import Loadder from "components/Loadder/Loadder"

const ViewDealerTaggedProduct = () => {
  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState(null)
  const [currentPage, setcurrentPage] = useState(1)

  const getUserData = JSON.parse(localStorage.getItem("authUser"))

  const getDealerTaggedProduct = () => {
    setLoading(true)
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOSTNAME}api/tag-inventory-manufacture-product/`,
      headers: {
        Authorization: `${getUserData.userData.token}`,
      },
    }
    axios
      .request(config)
      .then(response => {
        setTableData(response?.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getDealerTaggedProduct()
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "Sr.No",
        accessor: "id",
      },
      {
        Header: "Product Name",
        accessor: "RPD.pnumber.pname",
      },
      {
        Header: "Product Number",
        accessor: "RPD.pnumber.pnumber",
      },
      {
        Header: "Product  Consumables Name",
        accessor: "RPD.mpname",
      },
      {
        Header: "Tagged  Quantity",
        accessor: "qty",
      },
      {
        Header: "Dealer Name",
        accessor: "dealer",
        Cell: cellProps => {
          const row = cellProps.row.original.dealer

          return (
            <p>
              {row.firstName} {row.lastName}
            </p>
          )
        },
      },
    ],
    []
  )

  // Search
  const [query, setquery] = useState("")
  const onSearch = e => {
    setquery(e.target.value)
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOSTNAME}api/tag-inventory-manufacture-product/?query=${e.target.value}`,
      headers: {
        Authorization: `${getUserData.userData.token}`,
      },
    }
    setLoading(true)
    axios
      .request(config)
      .then(response => {
        setTableData(response?.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  //Pagination function
  const getPaginationData = (url, page) => {
    setcurrentPage(page)
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: url,
      headers: {
        Authorization: `${getUserData.userData.token}`,
      },
    }
    setLoading(true)
    axios
      .request(config)
      .then(response => {
        setTableData(response?.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Loadder active={loading}>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Tables" breadcrumbItem="Consumables Products" />

          <TableContainer
            count={tableData?.count}
            next={tableData?.next}
            previous={tableData?.previous}
            columns={columns}
            data={tableData?.results?.data || []}
            isGlobalFilter={true}
            isAddOptions={false}
            customPageSize={10}
            className="custom-header-css"
            removeCheckbox
            removeDelete
            onSearch={onSearch}
            currentPage={currentPage}
            goToNextPage={() =>
              getPaginationData(
                `${HOSTNAME}api/tag-inventory-manufacture-product/?query=${query}&page=${currentPage + 1
                }`,
                currentPage + 1
              )
            }
            goToLastPage={() =>
              getPaginationData(
                `${HOSTNAME}api/tag-inventory-manufacture-product/?query=${query}&page=${Math.ceil(
                  tableData?.count / 10
                )}`,
                Math.ceil(tableData?.count / 10)
              )
            }
            goToPreviousPage={() =>
              getPaginationData(
                `${HOSTNAME}api/tag-inventory-manufacture-product/?query=${query}&page=${currentPage - 1
                }`,
                currentPage - 1
              )
            }
            goToFirstPage={() =>
              getPaginationData(
                `${HOSTNAME}api/tag-inventory-manufacture-product/?query=${query}&page=${1}`,
                1
              )
            }
            getInputPaginationData={e =>
              getPaginationData(
                `${HOSTNAME}api/tag-inventory-manufacture-product/?query=${query}&page=${e.target.value}`,
                e.target.value
              )
            }
          />
        </div>
      </div>
    </Loadder>
  )
}

export default ViewDealerTaggedProduct
